import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import "../css/style.css";
import {
  ConvertDateTime,
  getUserData,
  s3Client,
} from "../../Base/helper/baseFunctions";
import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import AutoModeOutlinedIcon from "@mui/icons-material/AutoModeOutlined";
import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MaleAvatar from "../images/Male.jpg";
import FemaleAvatar from "../images/Female.jpg";
import TransgenderAvatar from "../images/Trans.jpg";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PersonIcon from "@mui/icons-material/Person";
import {
  Grid,
  Box,
  Paper,
  CardMedia,
  Card,
  CardContent,
  Typography,
  Tooltip,
  IconButton,
} from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import Base from "../../Base/views/Base";
import QuickLinks from "./QuickLinks";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { GetObjectCommand } from "@aws-sdk/client-s3";
import { AddMenuHeadingAction } from "../../../../store/Menu/Action";
import history from "../../../../history";
import MyTaskPopup from "../../ATS/views/ATSTask/MyTaskPopup";
import { GetSubscriptionAction } from "../../../../store/Ancillary/Subscribe/Action";
import { GetYearlyHolidayCalendarAction } from "../../../../store/Leave/YearlyHolidayCalendar/Action";
import BadgeIcon from "@mui/icons-material/Badge";
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

export default function MyProfile() {
  const [imageUrl, setImageUrl] = useState("");
  const userData = getUserData();
  const [openPopup, setOpenPopup] = useState(false);
  const [mode, setMode] = useState("");
  const [popupData, setPopupData] = useState([]);
  const { homeData } = useSelector((state) => state?.EmployeeDashboardReducer);
  const { quicklinksData } = useSelector(
    (state) => state?.EmployeeDashboardReducer
  );
  const { atsModuleData } = useSelector(
      (state) => state?.RoleAndAccessReducer?.ATSModuleReducer
    );
  const ExternalUserCoreHr = atsModuleData?.some(
    (item) => item.module_name === "External User CoreHr"
  );
  const visitorsManagementAccess = userData?.workspace_visitor_management_flag && userData?.enable_visitor_management && userData?.f_country_code === "IND"

  const { isMobile } = useSelector((state) => state?.MenuReducer);
  const useStyles = makeStyles((theme) =>
    createStyles({
      Paper: {
        boxShadow:
          "0px 3px 3px -2px #cbc3c3, 0px 3px 4px 0px rgb(242 242 242), 0px 1px 8px 0px rgb(242 242 242)",
        borderRadius: "25px",
      },
      profileItem: {
        display: "flex",
        alignItems: "center",
        gap: ".5rem",
      },
    })
  );
  const classes = useStyles();
  const dispatch = useDispatch();

  const areAllFalse = obj => obj && Object.values(obj)?.every(value => value === false);
  const ShowCoreHr = quicklinksData?.[0]?.corehr?.[0];

     const coreHr = [
        { name: "It's Me", icon: <BadgeIcon />, color: '#1769ff', show: ShowCoreHr?.['Its Me'] && !ExternalUserCoreHr, route: '/employee', },
        { name: 'Employee', icon: <AssignmentIndIcon />, color: '#ea4c89', show: ShowCoreHr?.['My Employee'], route: '/myemployee' },
      ];
    
      const VM_Module = [
        { name: "Dashboard", icon: <DashboardIcon />, color: '#1769ff', show: visitorsManagementAccess, route: '/visitors-dashboard', },
        { name: 'Report', icon: <AssignmentIndIcon />, color: '#ea4c89', show: visitorsManagementAccess, route: '/visitors-record' },
        { name: 'Visitor Entry', icon: <PersonIcon />, color: '#c32aa3', show: visitorsManagementAccess, route: '/visitors-management-region' },
      ];
      const handleMenuClick = (menu, route, name) => {
        sessionStorage.setItem("selectedMenu", menu);
        dispatch(AddMenuHeadingAction({ heading: menu }));
        if (route === '/ats/add-job/') {
          history.push({ pathname: route, state: { from: 'dashboard' } });
        }
        else if (name === 'Form Builder') {
          history.push({ pathname: route, state: { defaultValue: '4' } });
        }
        else {
          history.push(route);
        }
      }
  useEffect(() => {
    if (homeData?.[0]?.image) {
      getImageSignedUrl(homeData[0].image);
    }

  }, [homeData]);
  useEffect(() => {
    dispatch(GetSubscriptionAction());
    dispatch(GetYearlyHolidayCalendarAction({ year: 0 }));
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getImageSignedUrl = async (currentData) => {
    let filename = currentData;
    const bucketParams = {
      Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
      Key: filename,
    };
    try {
      const url = await getSignedUrl(
        s3Client,
        new GetObjectCommand(bucketParams),
        { expiresIn: 3 * 60 }
      ); // Adjustable expiration.
      setImageUrl(url);
      return url;
    } catch (err) {
      toast.error(err);
    }
  };
  const handleTaskClick = (menu, value) => {
    sessionStorage.setItem("selectedMenu", menu);
    dispatch(AddMenuHeadingAction({ heading: menu }));
    history.push({
      pathname: "/ats/tasks/",
      state: { defaultValue: value },
    });
  };

  const handleAdd = () => {
    setMode("Add");
    setOpenPopup(true);
  };

  return (
    <div className="home">
      <Base>
        <MyTaskPopup
          my_task={true}
          mode={mode}
          setMode={setMode}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
          data={popupData}
          setData={setPopupData}
          home={true}
        />
        <Box sx={{ maxHeight: "87vh", overflowY: "auto" }}>
          <Grid container>
            <Grid item xs={12}>
              <Paper elevation={1} className={classes.Paper}>
                <Card>
                  <CardMedia className="background_img"></CardMedia>
                  <CardContent
                    className="meepl-bgcolor"
                    sx={{
                      display: "flex",
                      gap: "1.5rem",
                      justifyContent: { xs: "center", md: "flex-start" },
                      flexDirection: { xs: "column", md: "row" },
                      alignItems: { xs: "center", md: "flex-start" },
                      paddingTop: "30px",
                    }}
                  >
                    <Box sx={{ display: "flex" }} className="Profile">
                      {homeData?.[0]?.image ? (
                        <img
                          width={120}
                          height={120}
                          style={{ padding: "4px 4px", borderRadius: "6px" }}
                          alt="user-img"
                          src={imageUrl}
                        />
                      ) : (
                        <img
                          width={120}
                          height={120}
                          style={{ padding: "4px 4px", borderRadius: "6px" }}
                          alt="user-img"
                          src={
                            homeData?.[0]?.gender === "Female"
                              ? FemaleAvatar
                              : homeData?.[0]?.gender === "Non-Binary"
                                ? TransgenderAvatar
                                : MaleAvatar
                          }
                        />
                      )}
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        justifyContent: { xs: "center", md: "flex-start" },
                        gap: 5,
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          gap: "1.25rem",
                          flexDirection: { xs: "column", md: "row" },
                          flexWrap: "wrap",
                          alignItems: { xs: "center", md: "end" },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            gap: ".5rem",
                            flexDirection: "column",
                            alignItems: { xs: "center", md: "flex-start" },
                          }}
                        >
                          <Typography
                            sx={{
                              textAlign: { xs: "center", md: "left" },
                                                          }}
                            variant="h4"
                          >
                            {homeData?.[0]?.name || homeData?.[0]?.user_name}
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              justifyContent: "center",
                              gap: "1.25rem",
                            }}
                          >
                            {homeData?.[0]?.user_creation_date && (
                              <div className={classes.profileItem}>
                                <AccessTimeIcon
                                  fontSize="small"
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "rgb(46 38 61 / 70%)",
                                  }}
                                />
                                <Typography variant="body1" fontWeight="500">
                                  <span style={{ fontStyle: "italic" }}>
                                    {" "}
                                    User Since: &nbsp;
                                  </span>
                                  {ConvertDateTime(
                                    homeData?.[0]?.user_creation_date
                                  )}
                                </Typography>
                              </div>
                            )}
                          </Box>
                        </Box>
                      </Box>
                    </Box>
                  </CardContent>
                </Card>
              </Paper>
            </Grid>

            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              sx={{
                paddingRight: isMobile ? "0" : "1.5rem",
                paddingBottom: "1.5rem",
                paddingTop: "1.5rem",
              }}
            >
               {!areAllFalse(ShowCoreHr) && (
                      <Grid item xs={12} sm={12} md={12} lg={12} pb={2}>
                        <Paper elevation={3} className="folder">
                          <div className="folder-title">CORE HR</div>
                          <Grid container spacing={2}>
                            {coreHr?.map((app, index) => (
                              app.show && (
                                <Grid item xs={6} sm={4} md={4} key={index}>
                                  <Box className="quick-app" onClick={() => handleMenuClick(app.name, app.route)}>
                                    <div className="quick-app-icon">{app.icon}</div>
                                    <div className="quick-app-name">{app.name}</div>
                                  </Box>
                                </Grid>
                              )
                            ))}
                          </Grid>
                        </Paper>
                      </Grid>
                    )}
                {homeData?.[0]?.enable_ats && (
                  <Grid container spacing={6} pb={2} >
                    <Grid item xs={12}>
                      <Paper elevation={1} className={classes.Paper}>
                        <Card>
                          <CardContent className="meepl-bgcolor">
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: "1rem",
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  mt:"-15px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#212B36",
                                    fontWeight: "800",
                                    letterSpacing: "0.4px",
                                  }}
                                >
                                  TASK
                                </span>

                                <Tooltip title="Add Task">
                                  <IconButton onClick={handleAdd}>
                                    <AddIcon />
                                  </IconButton>
                                </Tooltip>
                              </Box>

                              <Grid container spacing={2} mt={"-25px"}>
                                <Grid item xs={6} sm={4} md={4}>
                                  <Box
                                    className="quick-app"
                                    onClick={() => handleTaskClick("My Tasks", 0)}
                                  >
                                    <div className="quick-app-icon">
                                      {" "}
                                      <AutoModeOutlinedIcon />
                                    </div>
                                    <div
                                      style={{ marginBottom: "5px" }}
                                      className="quick-app-name"
                                    >
                                      To Do
                                    </div>
                                    <div
                                      style={{ fontWeight: "600" }}
                                      className="quick-app-name"
                                    >
                                      {homeData?.[0]?.task_to_do_count}
                                    </div>
                                  </Box>
                                </Grid>

                                <Grid item xs={6} sm={4} md={4}>
                                  <Box
                                    className="quick-app"
                                    onClick={() => handleTaskClick("My Tasks", 1)}
                                  >
                                    <div className="quick-app-icon">
                                      {" "}
                                      <AssignmentIndOutlinedIcon />
                                    </div>
                                    <div
                                      style={{ marginBottom: "5px" }}
                                      className="quick-app-name"
                                    >
                                      Assigned
                                    </div>
                                    <div
                                      style={{ fontWeight: "600" }}
                                      className="quick-app-name"
                                    >
                                      {homeData?.[0]?.task_assigned_count}
                                    </div>
                                  </Box>
                                </Grid>

                                <Grid item xs={6} sm={4} md={4}>
                                  <Box
                                    className="quick-app"
                                    onClick={() => handleTaskClick("My Tasks", 2)}
                                  >
                                    <div className="quick-app-icon">
                                      {" "}
                                      <CheckIcon />
                                    </div>
                                    <div
                                      style={{ marginBottom: "5px" }}
                                      className="quick-app-name"
                                    >
                                      Done
                                    </div>
                                    <div
                                      style={{ fontWeight: "600" }}
                                      className="quick-app-name"
                                    >
                                      {homeData?.[0]?.task_done_count}
                                    </div>
                                  </Box>
                                </Grid>
                              </Grid>
                            </Box>
                          </CardContent>
                        </Card>
                      </Paper>
                    </Grid>
                  </Grid>
                )}
          {/* Visitors Management Shorcuts */}
                {visitorsManagementAccess && (
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <Paper elevation={3} className="folder">
                        <div className="folder-title">Visitor Management</div>
                        <Grid container spacing={2}>
                          {VM_Module?.map((app, index) => (
                            app.show && (
                              <Grid item xs={6} sm={4} md={4} key={index}>
                                <Box className="quick-app" onClick={() => handleMenuClick(app.name, app.route)}>
                                  <div className="quick-app-icon">{app.icon}</div>
                                  <div className="quick-app-name">{app.name}</div>
                                </Box>
                              </Grid>
                            )
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                  )}
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              lg={6}
              sx={{
                paddingBottom: "1.5rem",
                paddingTop: "1.5rem",
              }}
            >
              <QuickLinks quicklinksData={quicklinksData} />
            </Grid>
          </Grid>
        </Box>
      </Base>
    </div>
  );
}
